
<template>
	<div> 
		<section id="section-location-form">
			<!-- <span class="forMobile locaitonMobileLogo"><Logo /> </span>
			<div v-if="!this.$root.customerDetails.number.length" class="landing_loginMobile " @click="toggleLogin">
				<p> Login | Sign Up 
				</p>
			</div>
			<div v-else @click="signout" class="landing_loginMobile " >
				<p> Sign Out 
				</p>
			</div> -->
			<div class="navigation landingNavigation">
				<a href="/" class="mobileLogo">
					<img src="/img/lhm_logo_w.png" class="img-fluid " style="margin-top: 20px; max-height: 70px;">
				</a>
				<div v-if="!this.$root.customerDetails.number.length" class="landing_loginDesktop" @click="toggleLogin">
					<p>
						<!-- <i class="fa fa-user-o user-iconLannding"></i> -->
						 Login | Sign Up</p>
				</div>
				<div @click="signout" v-else class="landing_loginDesktop" >
					<p>
						<!-- <i class="fa fa-user-o user-iconLannding"></i>  -->
					Sign Out</p>
				</div>
				<!-- <div class="landing_login" @click="toggleLogin">
					Login | Sign Up
				</div> -->
			</div>
				<img src="/img/locationHeart1.png" class="img-fluid HeartImageDesk" alt="">
			
			<div class="container locaitonInputWrap">
				<img src="/img/locationHeart1m.png" class="img-fluid forMobile" alt="">

				<!-- <h2 class="text-white landing_heading">
					 <vue-typer :repeat='0' caret-animation='smooth' type-delay='100' pre-type-delay='1000' erase-style='backspace' text='For the Love of Shopping...'></vue-typer>
				</h2> -->
				<!-- <h4 class="text-white landing_secondry">
					Showrooms at your doorstep. Get Delivered within 1 hour
				</h4> -->
				<div id="location-form" class="row mt-0">
					<!-- <select class="landingSelect col-md-2">
						<option value="noida" selected>Noida</option>
						<option value="delhi">Delhi</option>
						<option value="gurugram">Gurugram</option>
					</select> -->

					<!-- <div class="input-group mb-3 col-md-10 landingInput">
                                <input type="text" class="form-control" placeholder="Type Your Delivery Location Here" aria-label="Recipient's username" aria-describedby="basic-addon2">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="button">Button</button>
                                </div>
                            </div> -->
							

					<div class="input-group col-md-12 landingInput">
						<!-- <google-map /> --> 
						<!-- <gmap-autocomplete
							class="form-control location_input"
							placeholder="enter your delivery location to fast-forward your shopping"
							aria-label="Recipient's username"
							aria-describedby="basic-addon2"
							@place_changed="setPlace"
							:options="autocompleteOptions"
						>
						</gmap-autocomplete> -->
							<!-- <input
							class="form-control location_input"
							placeholder="enter your delivery location to fast-forward your shopping"
							aria-label="Recipient's username"
							aria-describedby="basic-addon2"
							v-model="placeinput"
							@keyup="placesuggest"
							:options="autocompleteOptions"
							/> -->
							<input class="form-control location_input"
							placeholder="enter your delivery location to fast-forward your shopping" 
							id="infd" 
							type="text"
							@input="placesuggest()"/>
						<!-- <input
							type="text"
							@place_changed="setPlace"
							class="form-control location_input"
							placeholder="Type Your Delivery Location Here"
							aria-label="Recipient's username"
							aria-describedby="basic-addon2"
						/> -->
						<div class="input-group-append" @click="getLocation">
							<span v-if="isLocateMe" class="input-group-text location-detect-btn">
								<img src="/img/detect.png" class="pr-2" />
								Locate me
								
								</span>
							<span v-else class="input-group-text location-detect-btn">
								
								<i class="fa fa-spinner fa-spin"> </i>
								
							</span
							>
						</div>
						<a
							href="#"
							class="btn-findStore text-white"
							role="button"
							aria-pressed="true"
							>Explore</a
						>
					</div>

					<div class="col-md-12" v-if="error != ''">
						<div class="landing_error">{{ error }}</div>
					</div>
						<ul class="landing-place-dropdown landing-autosuggest" v-if="autosuggestion">
							<li
							style="line-height:17.5px"
							  v-for="(suggest, i) in suggestions"
                              :key="i"
							  @click='getlatlong(suggest.place_id,suggest.terms,suggest.types)'
							>
							{{suggest.description}}
							</li>
						</ul>
				</div>
				<!-- <p class=" text-white newHeadinglin">
					<vue-typer :repeat='0' caret-animation='smooth' type-delay='100' pre-type-delay='1000' erase-style='backspace' @typed-char='onTypedChar' text=''></vue-typer>
				</p> -->
			
					<div class="text-white newHeadinglin">
						<p id="text">from the cart to your heart – from your favourite neighbourhood stores</p>
					</div>
				<!-- <h5 class="newHeadinglin">The joy of in-store shopping –– online</h5> -->
				<section id="section-info-working">
					<!-- <div id="info-working-head">
						<h2>Shop the Store from Home</h2> 
					</div> -->
					<div id="info-working-graphics" class="container">
						<div class="row">
							<div class="col-4">
								<img src="/img/newlocation1.png" />
								<p> The store is the star </p>
							</div>
							<div class="col-4">
								<img src="/img/newlocation2.png" />
								<p>From the store floor to your door</p>
							</div>
							<div class="col-4">
								<img src="/img/newlocation3.png" />
								<p>Instant gratification</p>
							</div>
						</div>
					</div>
				</section>
			</div>
		</section>

		<div
			class="modal size-guide-popup-container"
			v-bind:class="{ active: this.$root.login_popup === true }"
			id="coupon-modal"
		>
			<div class="modal-dialog" style="max-width: 530px">
				<div class="modal-content">
					<div class="modal-body">
						<!-- class="close" -->
						<button
							type="button"
							class="close popupClose"
							@click="close_login_popup()" >
							x
						</button>
						<Login />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import axios from "axios";
	import { VueTyper } from "vue-typer";
	import Logo from "../Header/Logo";
	import Login from "../Header/Login";
	import GoogleMap from "../../GoogleMap";

	export default {
		components: {
			Logo,
			Login,
			GoogleMap,
			VueTyper,
		},
		data() {
			return {
				placeinput:'',
				autosuggestion:false,
				suggestions:[],
				isLocateMe: true,
				error: "",
				center: { lat: 45.508, lng: -73.587 },
				markers: [],
				places: [],
				currentPlace: null,
				autocompleteOptions: {
					componentRestrictions: {
						country: ["in"],
					},
				},
			};
		},
		beforeMount(){
//get device token we get from app webview url
			let pushtoken=this.$route.query.token;
			let platform=this.$route.query.platform;
			const myArray = pushtoken.split("?t");
			let devicetoken = myArray[0];
			 $cookies.set(
				window.location.hostname.substring(10, 4) + "_devicetoken",
				devicetoken,
				"1y"
             );
			$cookies.set(
				window.location.hostname.substring(10, 4) + "_platform",
				platform,
				"1y"
             );
			 pushtoken=  $cookies.get(
              window.location.hostname.substring(10, 4) + "_devicetoken"
            );
			let customerId=$cookies.get(
              window.location.hostname.substring(10, 4) + "_customer"
            );

			 platform=$cookies.get(
              window.location.hostname.substring(10, 4) + "_platform"
            );
					
				var form = new FormData();
				form.append("fcm_device_token", devicetoken);
				form.append("customer_id", customerId);
				form.append("platform", platform);
				
				axios.post(`${this.$root.admin_api}/push-notification`,form)
				.then((res) => {
					console.log(res)
				})
				.catch((err) => {
					console.log(err)		
				});
		},
		mounted() {
			// this.geolocate();
			document.getElementById('pim_main').classList.add("landingPage");
			
			var i = 0;
			// var A = 0;
			var tag = document.getElementById("text");
			var html = document.getElementById("text").innerHTML;
			var attr = tag.setAttribute("data", html);
			var txt = tag.getAttribute("data");
			var speed = 170;
			function typeWriter() {
				if (i <= txt.length) {
					document.getElementById("text").innerHTML = txt.slice(0 , i + 1);
					i++;
					setTimeout(typeWriter, speed);
				}
					//console.log(document.getElementById("text").innerHTML);
			}
			typeWriter();		
		},
		
	 
		methods: {
			getlatlong(placeid,terms,types){
				this.$root.locationPlaceId = placeid;
				$cookies.set(
					window.location.hostname.substring(10, 4) + "_location_placeId",
					this.$root.locationPlaceId,
					"1y"
				);
				var form = new FormData();
				form.append("placeId", placeid);
				axios.post(`${this.$root.api_url}/pim/get-lat-long`,form)
				.then((res) => {
			
					if(res.success=true){
					        
					 		this.$root.location.lat = res.data.data.google_lat;
							this.$root.location.long = res.data.data.google_long;
							this.$root.isLocation = true;

							$cookies.set(
								window.location.hostname.substring(10, 4) + "_location_lat",
								this.$root.location.lat,
								"1y"
							);
							$cookies.set(
								window.location.hostname.substring(10, 4) + "_location_long",
								this.$root.location.long,
								"1y"
							);
							this.placeinput=''
							this.suggestions=[]
							
							if(res.data.data.google_sublocaility){
							this.$root.cityName = res.data.data.google_sublocaility;
							}
							else{
								this.$root.cityName = res.data.data.google_locality;
							}
						    this.$root.locationAddress = res.data.data.google_formatted_address;
						   
								window.localStorage.setItem("location-landing", true);
				
				            window.location.reload()
								
					}
					else{
						console.log(res.data.error_message)
					}
				})
				.catch((err) => {
					console.log(err)		
				});

			},
		
			placesuggest(){
				let val=document.getElementById("infd").value
			   if(val.length>2){
				var form = new FormData();
				form.append("name", val);
				axios.post(`${this.$root.api_url}/pim/place-autosuggestion`,form)
				.then((res) => {
					this.autosuggestion=true
					if(res.data.status=='OK'){
					this.suggestions=res.data.predictions
					console.log(this.suggestions)
					}
				})
				.catch((err) => {
					console.log(err)		
				});
			   }
			},
			

			

			signout () {
				$cookies.remove(window.location.hostname.substring(10, 4) + "_customer");
				$cookies.remove(window.location.hostname.substring(10, 4) + "_cs");
				this.$root.customerDetails.name = '';
				this.$root.customer_detail = {};
				this.$root.customerDetails.number = '';


			},
			mark(event) {
				// console.log(event.latLng.lat());
				// console.log(event.latLng.lng());
			},
			// receives a place object via the autocomplete component
			setPlace(place) {
		
				window.localStorage.setItem("location-landing", true);
				// console.log(place);
				this.$root.locationPlaceId = place.place_id;
				$cookies.set(
					window.location.hostname.substring(10, 4) + "_location_placeId",
					this.$root.locationPlaceId,
					"1y"
				);
				this.$root.location.lat = place.geometry.location.lat();
				this.$root.location.long = place.geometry.location.lng();
				this.$root.isLocation = true;

				$cookies.set(
					window.location.hostname.substring(10, 4) + "_location_lat",
					this.$root.location.lat,
					"1y"
				);
				$cookies.set(
					window.location.hostname.substring(10, 4) + "_location_long",
					this.$root.location.long,
					"1y"
				);
				this.currentPlace = place;
				window.location.reload()
			},
			addMarker() {
				if (this.currentPlace) {
					const marker = {
						lat: this.currentPlace.geometry.location.lat(),
						lng: this.currentPlace.geometry.location.lng(),
					};
					this.markers.push({ position: marker });
					this.places.push(this.currentPlace);
					this.center = marker;
					this.currentPlace = null;
				}
			},
			geolocate: function () {
				navigator.geolocation.getCurrentPosition((position) => {
					this.center = {
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					};
				});
			},
			toggleLogin() {
				 
				this.$root.login_popup = true;
			},
			close_login_popup() {
				this.$root.login_popup = false;
			},
			getLocation() {
				if(navigator.permissions) {
					navigator.permissions
					.query({ name: "geolocation" })
					.then((permissions) => {
						if (permissions.state == "denied") {
							
							this.error =
								"You have blocked LHM from tracking your location. To use this, change your location settings in browser.";
						} else {
							return;
						}
					});
				}
				if (navigator.geolocation) {
						this.isLocateMe = false
					navigator.geolocation.getCurrentPosition((position) => {
					
						this.$root.location.lat = position.coords.latitude;
						this.$root.location.long = position.coords.longitude;
						this.isLocateMe = true
						this.$root.isLocation = true;
						
						$cookies.set(
							window.location.hostname.substring(10, 4) + "_location_lat",
							this.$root.location.lat,
							"1y"
						);
						$cookies.set(
							window.location.hostname.substring(10, 4) + "_location_long",
							this.$root.location.long,
							"1y"
						);
						// this.$router.push('/')
						//  console.log(position);
					}, (error) => {
						
						 this.isLocateMe = true
						},
						{
							enableHighAccuracy: true,
							timeout: 5000,
  							maximumAge: 0
							// , timeout: 5000
						})
						
				} else {
					this.error =
						"You have blocked LHM from tracking your location. To use this, change your location settings in browser.";
				}
			},


			
		},
	};
</script>

<style> 
.landing-autosuggest{ 
    display: block;
    margin-top: 30px;
    padding: 0;
    max-height: 400px;
    border: none;
    

}
.container.locaitonInputWrap {
    position: relative;
}
.landing-place-dropdown{
	
    position: absolute;
        top: 61px;
    /* left: 9px; */
    z-index: 1000;
    float: left;
    margin: .125rem 0 0;
    font-size: 1rem;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;

}
	 #pim_main.landingPage{
		 padding-bottom: 0;
	 }
	
	#section-location-form {
		margin-top: -96px;
		position: relative;
	}
	.landing_loginDesktop {
		cursor: pointer;
		color: #fff;
		margin-left: auto;
	}
	.landing_loginDesktop p {
		margin: 0;
		padding: 0 20px;
		font-family: 'lhmRegular';
	}
	.landing_loginDesktop i {
		font-size: 20px;
		margin-right: 15px;
		margin-bottom: -8px;
	}
	.locaitonInputWrap {
		max-width: 950px;
		margin-top: 10px;
	}
	.btn-findStore { 
			background: #000 !important;
		}

		.landing-place-dropdown li {
    padding: 10px;
    cursor: pointer;
    font-size: 12px;
    border: 1px solid #ebebeb;
}
.landing-place-dropdown {
    width: 590px;
    border-radius: 0;
    left: 15px;
    right: auto;
}
.landing-place-dropdown li:hover {
    background: #ebebeb;
}
div#location-form {
    position: relative;
}
	@media screen and (max-width: 767px) {
		#location-form .input-group.col-md-12.landingInput {
    padding: 10px 0px;
    width: 90%;
    margin: auto;
}
		.landing-place-dropdown {
    width: 90%;
    border-radius: 0;
    left: 0; right: 0; margin: 0 auto;
    top: 57px;
    padding: 0;
    box-sizing: border-box;
}
		.landing_loginDesktop{
			padding-top: 12px;
		}
		.landingNavigation .mobileLogo{
			margin-left: 5px;
		}
		.landingPage{
			margin-top: 0 !important;	
		}
		.locaitonMobileLogo{
			text-align: center;
			margin-top: 75px;
			/* display: inline-block !important; */
			width: 100%;
			position: absolute;
		}
		.locaitonMobileLogo .mobileLogo img{
			    margin-top: 100px !important;
				max-height: 60px !important;
				transform: translateX(45%) !important;
				padding: 0 !important;
		}
		.container.locaitonInputWrap{
    		margin-top: 100px;
		}
		.btn-findStore {
			padding: 16px 64px;
			background: #4c4c4c !important;
		}
		#section-location-form {
			margin-top: -55px;
		}
		#info-working-head h2 {
			padding: 0px 10px;
		}
	}
	
</style>